import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/SectionMedia';
import RankingSection from './components/SectionRanking';
import TopicsSection from './components/SectionTopics';
import FeaturesSection from './components/SectionFeatures';
import ContactSection from './components/SectionContact';
import CarouselSection from './components/SectionCarousel';
import IndexSection from './components/SectionIndex';
import FaqSection from './components/SectionFaq';
import UpdatesSection from './components/SectionUpdates';
import CommentsSection from './components/SectionComments';
import AppSection from './components/SectionApp';
import CardsSection from './components/SectionCards';
import AboutSection from './components/SectionAbout';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <RankingSection />
        <TopicsSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <IndexSection />
        <FaqSection />
        <UpdatesSection />
        <CommentsSection />
        <AppSection />
        <CardsSection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}